<template>
    <div v-wechat-title="title">
        <crud-facecade :url="url" :columns="columnList" :buttons="[]" :tableHeight="tableHeight" :addButton="{ permission: 'instrument:create' }" :updateButton="{ permission: 'instrument:update' }">
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DicInstrument`,
    props: {

    },
    data() {
        return {
            title: `器械维护`,
            url: { baseURL: `/api/AcisSystem/Instrument` }
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `100`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                readonly: false,
                options: `is_enabled`,
                default: false
            }]
        }
    },
    methods: {
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/Instrument.vue